import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import { Spinner, Flex, FlexColumn, Heading, Text, Box } from 'core/components';

class VizWrapper extends Component {
  renderHeading() {
    const { heading, subHeading, subtitle, loading, menu } = this.props;
    return (
      <>
        <Flex justifyContent="space-between" gap={4}>
          <FlexColumn>
            <Heading level={4} mb="4px">
              {heading}
              {subHeading}
            </Heading>
            {subtitle}
          </FlexColumn>
          <Flex justifyContent="space-between">{menu}</Flex>
        </Flex>
        {loading && (
          <Flex flexWrap="wrap">
            <Text muted mr={1}>
              loading...
            </Text>
            <Spinner intent="primary" size="14" />
          </Flex>
        )}
      </>
    );
  }

  emptyState = () => {
    const {
      noResultsTitle = 'No Results',
      noResultsDescription = 'Results are not currently available for this time range.'
    } = this.props;

    return (
      <Flex alignItems="center" pb={1}>
        <Flex flexDirection="column">
          <Heading level={6} mb={0.5}>
            {noResultsTitle}
          </Heading>
          <Box>
            <Text small muted>
              {noResultsDescription}
            </Text>
          </Box>
        </Flex>
      </Flex>
    );
  };

  render() {
    const { renderContent, children, loading } = this.props;
    return (
      <Flex my={3} flexDirection="column">
        {this.renderHeading()}
        <Flex mt={2} flexDirection="column">
          {!!renderContent && !loading && children}
          {!renderContent && !loading && this.emptyState()}
        </Flex>
      </Flex>
    );
  }
}

export default withTheme(VizWrapper);
